(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('FeedbackButtonFactory', FeedbackButtonFactory);

  FeedbackButtonFactory.$inject = ['$translate', '$q'];
  function FeedbackButtonFactory ($translate, $q) {

    let humanyLoaded = false;
    let currentPage = null;

    const service = {
      getHumanyWidget: getHumanyWidget,
      loadHumany: loadHumany,
      isHumanyLoaded: isHumanyLoaded
    };
    return service;

    function getHumanyWidget (state) {
      const widgetName = 'w2p-feedback-lightbox-sv';
      currentPage = state;

      return {
        name: widgetName
      };
    }

    function isHumanyLoaded () {
      return humanyLoaded;
    }

    function humanyInitializer ($q) {
      const d = $q.defer();
      Humany.configure(function (config) {
        config.navigationMode('hashless');
        Humany.ready(function () {
          d.resolve(config);
        });
      });
      return d.promise;
    }

    function loadHumany (widgetName) {
      humanyLoaded = true;

      humanyInitializer($q).then(function (config) {
        config(widgetName).registerPlugin({
          init: function (data, context) {
            const serviceClient = context.container.get('serviceClient');
            console.log(serviceClient);
            serviceClient.parameters.set('current-page', currentPage);
          }
        });
      });
    }
  }
})();
